import { Button, CircularProgress } from "@mui/material";
import { useState } from "react";

import { unlockUser } from "../../../api/customer";
import useNotify from "../../../hooks/useNotify";
import { useSetUnlockCustomerStore } from "../../../stores/customerStore";
import Text from "../../atoms/Text";
import UnlockIcon from "../../icons/ui/UnlockIcon";

export const ActionUnlock = (id: string | number, status: string) => {
  const { setNotifySuccess } = useNotify();
  const setUnlockCustomer = useSetUnlockCustomerStore();
  const [isUnlock, setIsUnlock] = useState(false);

  return (
    <>
      {status === "LOCKED" && (
        <Button
          key={id}
          onClick={event => {
            event.stopPropagation();
            setIsUnlock(true);
            unlockUser(id.toString())
              .then(res => {
                if (res.data) {
                  if (
                    res.data.message &&
                    res.data.message === "User Successfully Unlocked"
                  ) {
                    setUnlockCustomer(id.toString(), res.data?.accountStatus);
                  }
                  setNotifySuccess(res.data?.message);
                }
              })
              .finally(() => setIsUnlock(false));
          }}
          disabled={isUnlock}
          variant="secondary"
          size="small"
          endIcon={isUnlock && <CircularProgress size={15} />}
          sx={{
            height: 32,
            gap: 1,
            "&.MuiButtonBase-root": {
              padding: "0 12px 0 8px",
            },
            "& .MuiButton-endIcon": {
              marginRight: 0,
              marginLeft: "-8px",
            },
          }}
        >
          <Text variant="subtitle_small">Unlock</Text>
          <UnlockIcon />
        </Button>
      )}
    </>
  );
};
